var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcDialPad = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "95107942-1C6B-4996-AA9E-B0F0C5D2D72E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "POC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00.00.01-Onboarding",
    transform: "translate(-24.000000, -300.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dial-pad-hi",
    transform: "translate(24.000000, 300.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8725,36 L27.14,36 C27.6149649,36 28,36.3850351 28,36.86 L28,43.14 C28,43.6149649 27.6149649,44 27.14,44 L20.8725,44 C20.3975351,44 20.0125,43.6149649 20.0125,43.14 L20.0125,36.86 C20.0125,36.3850351 20.3975351,36 20.8725,36 Z",
    id: "Rectangle-path",
    fill: "#E60000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.14,43 L20.8725,43 C20.3975351,43 20.0125,42.6149649 20.0125,42.14 L20.0125,43.14 C20.0125,43.6149649 20.3975351,44 20.8725,44 L27.14,44 C27.6149649,44 28,43.6149649 28,43.14 L28,42.14 C28,42.6149649 27.6149649,43 27.14,43 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8725,26 L27.14,26 C27.6149649,26 28,26.3850351 28,26.86 L28,33.14 C28,33.6149649 27.6149649,34 27.14,34 L20.8725,34 C20.3975351,34 20.0125,33.6149649 20.0125,33.14 L20.0125,26.86 C20.0125,26.3850351 20.3975351,26 20.8725,26 Z",
    id: "Rectangle-path",
    fill: "#EBEBEB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.14,33 L20.8725,33 C20.3975351,33 20.0125,32.6149649 20.0125,32.14 L20.0125,33.14 C20.0125,33.6149649 20.3975351,34 20.8725,34 L27.14,34 C27.6149649,34 28,33.6149649 28,33.14 L28,32.14 C28,32.6149649 27.6149649,33 27.14,33 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8725,16 L27.14,16 C27.6149649,16 28,16.3850351 28,16.86 L28,23.14 C28,23.6149649 27.6149649,24 27.14,24 L20.8725,24 C20.3975351,24 20.0125,23.6149649 20.0125,23.14 L20.0125,16.86 C20.0125,16.3850351 20.3975351,16 20.8725,16 Z",
    id: "Rectangle-path",
    fill: "#EBEBEB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.14,23 L20.8725,23 C20.3975351,23 20.0125,22.6149649 20.0125,22.14 L20.0125,23.14 C20.0125,23.6149649 20.3975351,24 20.8725,24 L27.14,24 C27.6149649,24 28,23.6149649 28,23.14 L28,22.14 C28,22.6149649 27.6149649,23 27.14,23 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8725,6 L27.14,6 C27.6149649,6 28,6.38503512 28,6.86 L28,13.14 C28,13.6149649 27.6149649,14 27.14,14 L20.8725,14 C20.3975351,14 20.0125,13.6149649 20.0125,13.14 L20.0125,6.86 C20.0125,6.38503512 20.3975351,6 20.8725,6 Z",
    id: "Rectangle-path",
    fill: "#EBEBEB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.14,13 L20.8725,13 C20.3975351,13 20.0125,12.6149649 20.0125,12.14 L20.0125,13.14 C20.0125,13.6149649 20.3975351,14 20.8725,14 L27.14,14 C27.6149649,14 28,13.6149649 28,13.14 L28,12.14 C28,12.6149649 27.6149649,13 27.14,13 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.86,26 L38.1275,26 C38.6024649,26 38.9875,26.3850351 38.9875,26.86 L38.9875,33.14 C38.9875,33.6149649 38.6024649,34 38.1275,34 L31.86,34 C31.3850351,34 31,33.6149649 31,33.14 L31,26.86 C31,26.3850351 31.3850351,26 31.86,26 Z",
    id: "Rectangle-path",
    fill: "#EBEBEB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1275,33 L31.86,33 C31.3850351,33 31,32.6149649 31,32.14 L31,33.14 C31,33.6149649 31.3850351,34 31.86,34 L38.1275,34 C38.6024649,34 38.9875,33.6149649 38.9875,33.14 L38.9875,32.14 C38.9875,32.6149649 38.6024649,33 38.1275,33 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.86,16 L38.1275,16 C38.6024649,16 38.9875,16.3850351 38.9875,16.86 L38.9875,23.14 C38.9875,23.6149649 38.6024649,24 38.1275,24 L31.86,24 C31.3850351,24 31,23.6149649 31,23.14 L31,16.86 C31,16.3850351 31.3850351,16 31.86,16 Z",
    id: "Rectangle-path",
    fill: "#EBEBEB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1275,23 L31.86,23 C31.3850351,23 31,22.6149649 31,22.14 L31,23.14 C31,23.6149649 31.3850351,24 31.86,24 L38.1275,24 C38.3577442,24.0033469 38.5797136,23.9142197 38.7437086,23.7525743 C38.9077036,23.5909288 39,23.3702686 39,23.14 L39,22.14 C39,22.3702686 38.9077036,22.5909288 38.7437086,22.7525743 C38.5797136,22.9142197 38.3577442,23.0033469 38.1275,23 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.86,6 L38.1275,6 C38.6024649,6 38.9875,6.38503512 38.9875,6.86 L38.9875,13.14 C38.9875,13.6149649 38.6024649,14 38.1275,14 L31.86,14 C31.3850351,14 31,13.6149649 31,13.14 L31,6.86 C31,6.38503512 31.3850351,6 31.86,6 Z",
    id: "Rectangle-path",
    fill: "#EBEBEB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1275,13 L31.86,13 C31.3850351,13 31,12.6149649 31,12.14 L31,13.14 C31,13.6149649 31.3850351,14 31.86,14 L38.1275,14 C38.3577442,14.0033469 38.5797136,13.9142197 38.7437086,13.7525743 C38.9077036,13.5909288 39,13.3702686 39,13.14 L39,12.14 C39,12.3702686 38.9077036,12.5909288 38.7437086,12.7525743 C38.5797136,12.9142197 38.3577442,13.0033469 38.1275,13 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86,26 L16.1275,26 C16.6024649,26 16.9875,26.3850351 16.9875,26.86 L16.9875,33.14 C16.9875,33.6149649 16.6024649,34 16.1275,34 L9.86,34 C9.38503512,34 9,33.6149649 9,33.14 L9,26.86 C9,26.3850351 9.38503512,26 9.86,26 Z",
    id: "Rectangle-path",
    fill: "#EBEBEB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1275,33 L9.86,33 C9.38503512,33 9,32.6149649 9,32.14 L9,33.14 C9,33.6149649 9.38503512,34 9.86,34 L16.1275,34 C16.3577442,34.0033469 16.5797136,33.9142197 16.7437086,33.7525743 C16.9077036,33.5909288 17,33.3702686 17,33.14 L17,32.14 C17,32.3702686 16.9077036,32.5909288 16.7437086,32.7525743 C16.5797136,32.9142197 16.3577442,33.0033469 16.1275,33 L16.1275,33 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86,16 L16.1275,16 C16.6024649,16 16.9875,16.3850351 16.9875,16.86 L16.9875,23.14 C16.9875,23.6149649 16.6024649,24 16.1275,24 L9.86,24 C9.38503512,24 9,23.6149649 9,23.14 L9,16.86 C9,16.3850351 9.38503512,16 9.86,16 Z",
    id: "Rectangle-path",
    fill: "#EBEBEB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1275,23 L9.86,23 C9.38503512,23 9,22.6149649 9,22.14 L9,23.14 C9,23.6149649 9.38503512,24 9.86,24 L16.1275,24 C16.3577442,24.0033469 16.5797136,23.9142197 16.7437086,23.7525743 C16.9077036,23.5909288 17,23.3702686 17,23.14 L17,22.14 C17,22.3702686 16.9077036,22.5909288 16.7437086,22.7525743 C16.5797136,22.9142197 16.3577442,23.0033469 16.1275,23 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86,6 L16.1275,6 C16.6024649,6 16.9875,6.38503512 16.9875,6.86 L16.9875,13.14 C16.9875,13.6149649 16.6024649,14 16.1275,14 L9.86,14 C9.38503512,14 9,13.6149649 9,13.14 L9,6.86 C9,6.38503512 9.38503512,6 9.86,6 Z",
    id: "Rectangle-path",
    fill: "#EBEBEB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1275,13 L9.86,13 C9.38503512,13 9,12.6149649 9,12.14 L9,13.14 C9,13.6149649 9.38503512,14 9.86,14 L16.1275,14 C16.3577442,14.0033469 16.5797136,13.9142197 16.7437086,13.7525743 C16.9077036,13.5909288 17,13.3702686 17,13.14 L17,12.14 C17,12.3702686 16.9077036,12.5909288 16.7437086,12.7525743 C16.5797136,12.9142197 16.3577442,13.0033469 16.1275,13 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.12
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcDialPad);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_dial_pad.60a50efbc1c47517b40990d8b09c58bb.svg";